var _path, _path2, _g, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79091 20.9166H4.70133C2.15549 20.9166 0.0836182 18.8447 0.0836182 16.2968V4.70408C0.0836182 2.15617 2.15549 0.083252 4.70133 0.083252H9.77945C12.3274 0.083252 14.4003 2.15617 14.4003 4.70408V5.67492C14.4003 6.10617 14.0503 6.45617 13.619 6.45617C13.1878 6.45617 12.8378 6.10617 12.8378 5.67492V4.70408C12.8378 3.01659 11.4659 1.64575 9.77945 1.64575H4.70133C3.01695 1.64575 1.64612 3.01659 1.64612 4.70408V16.2968C1.64612 17.9833 3.01695 19.3541 4.70133 19.3541H9.79091C11.4701 19.3541 12.8378 17.9874 12.8378 16.3083V15.326C12.8378 14.8947 13.1878 14.5447 13.619 14.5447C14.0503 14.5447 14.4003 14.8947 14.4003 15.326V16.3083C14.4003 18.8499 12.3315 20.9166 9.79091 20.9166Z",
    fill: "#FE5C73"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_21",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 15,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37085 9.71875H21.476V11.2812H7.37085V9.71875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6948 11.2812H8.1521C7.72085 11.2812 7.37085 10.9312 7.37085 10.5C7.37085 10.0687 7.72085 9.71875 8.1521 9.71875H20.6948C21.1261 9.71875 21.4761 10.0687 21.4761 10.5C21.4761 10.9312 21.1261 11.2812 20.6948 11.2812Z",
    fill: "#FE5C73"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_375_21",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 6,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8641 6.68237H21.476V14.3186H16.8641V6.68237Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_375_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6451 14.3186C17.4451 14.3186 17.2441 14.2425 17.092 14.0884C16.7878 13.7821 16.7889 13.2884 17.0941 12.9842L19.5878 10.4998L17.0941 8.01649C16.7889 7.71232 16.7868 7.21857 17.092 6.91232C17.3962 6.60607 17.8899 6.60607 18.1962 6.91024L21.2462 9.9467C21.3941 10.0925 21.4764 10.2925 21.4764 10.4998C21.4764 10.7071 21.3941 10.9071 21.2462 11.0529L18.1962 14.0904C18.0441 14.2425 17.8441 14.3186 17.6451 14.3186Z",
    fill: "#FE5C73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.90f64f171132445a1a37fa4c82444080.svg";
export { ForwardRef as ReactComponent };